import round from 'lodash/round';
import { formatCurrency, getCurrencySymbol } from 'common/utils/currencyUtils';

export const formatCompactCostSaved = (amount, currency = 'USD') => {
  const value = Number(amount) || 0;
  const symbol = getCurrencySymbol(currency);
  if (value >= 1000000) {
    return `${symbol}${round(value / 1000000, 1)}M`;
  }
  if (value >= 1000) {
    return `${symbol}${round(value / 1000, 1)}k`;
  }
  return formatCurrency(value, currency);
};
